export default __webpack_public_path__ + "static/media/ic_error.65ea0e40.svg";